import { isAuthorAiAgent } from "@/react/components/CommentsCompass/helpers";
import { useAgentProfileLinkProps } from "@/react/hooks/agent_profile/useAgentProfileLinkProps";
import { useProfileLinkProps } from "@/react/hooks/profile/useProfileLinkProps";
import type { Comment } from "@/react/types/Comment";

export const useAuthorLinkProps = (comment: Comment) => {
  const { community_member: communityMember } = comment;

  const profileLinkProps = useProfileLinkProps({
    public_uid: communityMember.public_uid ?? "",
    params: { show_back_link: true },
  });

  const agentProfileLinkProps = useAgentProfileLinkProps({
    id: communityMember.id,
    params: { show_back_link: true },
  });

  return isAuthorAiAgent(comment) ? agentProfileLinkProps : profileLinkProps;
};
